import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {AppSettings} from '../../app-settings';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import {SessionService} from '../../Services/session.service';
import {Subscription} from 'rxjs';
import { Router } from '@angular/router';
import { EventService } from "../../Services/event.service";
declare var KM:any;
@Component({
  selector: 'personalized-study-planner',
  templateUrl: './personalized-study-planner.component.html',
  styleUrls: ['./personalized-study-planner.component.css']
})
export class PersonalizedStudyPlannerComponent implements OnInit {

  @ViewChild('iframePlanner', { static: true }) iframe: ElementRef;
  showIframe:boolean = false;
  pspURL:any;
  iframeOption:string;
  closeAppIcon =  AppSettings.cdnUrl +"assets/images/psp_close.png";
  userInfoSubscription:Subscription;
  userName:string;
  isUserHasPSPPlan:boolean;
  constructor(private httpClientService: HttpClientService , private sessionService: SessionService,private router:Router,private sanitizer: DomSanitizer, private eventService: EventService) { }

  ngOnInit()
  {
    this.getUserProfile();
    this.getFullName();

  }
  getFullName() {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => {
      if(data != "")
      {
        this.userName = data.username;
        this.isUserHasPSPPlan = data.userCreatedGmatPlanner;
        this.setIframeURL();
      }
    });
  }
  setIframeURL()
  {
    if(this.router.url == '/study-planner')
    {
      this.iframeOption = "scoreUI";
      this.pspURL = this.sanitizer.bypassSecurityTrustResourceUrl(AppSettings.pspURL+'/study-planner');
    }
    else if(this.router.url == '/admin-study-planner')
    {
      this.iframeOption = "scoreUI";
      this.pspURL = this.sanitizer.bypassSecurityTrustResourceUrl(AppSettings.pspURL+'/admin-study-planner');
    }
    else if(this.router.url == '/your-calendar')
    {
      this.iframeOption = "calendarUI";
      this.pspURL = this.sanitizer.bypassSecurityTrustResourceUrl(AppSettings.pspURL+'/your-calendar');
    }
    else if(this.router.url == '/your-personalized-view')
    {
      this.iframeOption = "HTMLUI";
      this.pspURL = this.sanitizer.bypassSecurityTrustResourceUrl(AppSettings.pspURL+'/your-personalized-view');
    }
  }
  goBackToDashboard()
  {
    this.eventService.track('PSP_Abandoned', {}, this.userName);
    this.router.navigate(['dashboard']);
  }

  ngOnDestroy()
  {
      this.userInfoSubscription.unsubscribe();
  }

  iframeLoad()
  {/*
    var that = this;
    setTimeout(()=>{

        let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
        let headerClose = doc.getElementsByClassName("cross_btn_contain")[0];
        //headerClose.style.display = 'block';
        if(typeof headerClose.addEventListener !== undefined)
        {
          headerClose.addEventListener('click', that.routeToDashboard , false);
          console.log("hello1");
        }
        else if(typeof headerClose.attachEvent  !== undefined)
        {
          headerClose.attachEvent ('onclick', that.routeToDashboard , false);
          console.log("hello2");
        }

       }, 20);*/
  }

  routeToDashboard()
  {
    console.log("hello");
    //this.router.navigateByUrl('/dashboard');
    window.location.href = AppSettings.restApiUrl+'/secure-lms/dashboard';
  }

  getUserProfile()
  {
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/user/info', headers)
      .subscribe(
      (data) => {
        this.sessionService.getUserInfo(data);
    }
    );
  }

}
